import { IAsset } from '@core';
import { queryClient } from '../config/client';
import { getSwingImagesKey } from '../hooks/useSwingImages';

export const updateSwingImages = (uuid: string, images: IAsset[]) => {
    queryClient.setQueryData<IAsset[]>(getSwingImagesKey(uuid), images);
};
